<!--
  商家
  lovi 2020-06-19
-->
<template>
  <div class="merchant">
    <van-cell :title="$t('life.merchantName')" :value="data.shop_name" />
    <van-cell :title="$t('life.merchantAddress')" :value="data.shop_address" />
    <van-cell :title="$t('life.merchantNumber')">
      <span slot="default" @click="_telephone(data.phone)">
        {{ data.phone }}
      </span>
    </van-cell>
    <van-cell :title="$t('life.openingHours')" :value="data.business_time" />
    <van-cell :title="$t('life.merchantAnnouncement')" :value="data.ad_text" />
    <van-cell :title="$t('life.merchantPicture')" class="cell-image">
      <div class="image-wrap" slot="label">
        <div
          class="image"
          @click="clickImage(data.shop_img, index)"
          v-for="(item, index) in data.shop_img"
          :key="index"
        >
          <img :src="httpUrl + item.url" />
        </div>
      </div>
    </van-cell>
    <van-cell :title="$t('life.businessQualification')" class="cell-image">
      <div class="image-wrap" slot="label">
        <div
          class="image"
          @click="clickImage(data.shop_others_img, index)"
          v-for="(item, index) in data.shop_others_img"
          :key="index"
        >
          <img :src="httpUrl + item.url" />
        </div>
      </div>
    </van-cell>
    <van-image-preview
      v-model="imageFlag"
      :images="images"
      :startPosition="imagesCur"
      @change="onChange"
    >
      <template v-slot:index>{{ imagesIndex }}</template>
    </van-image-preview>
  </div>
</template>

<script>
export default {
  props: ["data"],
  components: {},
  data() {
    return {
      imageFlag: false,
      images: [],
      imagesCur: 0,
      imagesIndex: 1
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    clickImage(data, index) {
      // 点击查看图片
      this.imageFlag = true;
      this.imagesCur = index;
      this.images = [];
      for (let i = 0; i < data.length; i++) {
        this.images.push(this.httpUrl + data[i].url);
      }
      console.log("images", this.images);
    },
    onChange(index) {
      // 点击默认图片索引
      console.log("onChange", index + 1);
      this.imagesIndex = index + 1;
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  &.cell-image {
    .van-cell__title {
      flex: 1;
    }
    .van-cell__value {
      flex: 0;
    }
  }
  .van-cell__title {
    flex: initial;
  }
  .van-cell__title,
  .van-cell__value {
    font-size: 14px;
  }
}
.image-wrap {
  margin-top: 5px;
  display: flex;
  justify-content: flex-start;
  .image {
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 80px;
    border-radius: 4px;
    overflow: hidden;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
